// Import CSS
import './main.css';
import './responsive.css';
import './styles/fontawesome.css';

// Import icon font system
import { initializeFontAwesome } from './icon-fonts.js';

// Import all JavaScript modules
import './data.js';
import './svg-events.js';
import './line-messages.js';
import './station-ui.js';
import './theme-system.js';
import './weather-widget.js';
import './location.js';
import './next-train.js';
import './mobile-line-switcher.js';
import './bikeshare-api.js';

// Initialize Font Awesome icons when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    initializeFontAwesome();
});